import { Database } from '@nozbe/watermelondb'
import { ComponentInfoChatVO } from '@repo/types'
import Chat from '../model/Chat'

export const createChat = async (payload: ComponentInfoChatVO, database: Database) => {
  const chats = database.collections.get<Chat>('chats')

  return await database.write(
    async () => await chats.create((chat: Chat) => chat.setChatByComponentInfoChatVO(payload))
  )
}
